import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cuál es el tratamiento más rápido para la depresión?",
    answer:
      "SAINT® es el protocolo de tratamiento para la depresión autorizado por la FDA más rápido: 50 sesiones en cinco días. Está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos.",
  },
  {
    question: "¿La TMS es un tratamiento rápido para la depresión?",
    answer:
      "La TMS convencional dura unas seis semanas. SAINT® comprime el tratamiento en cinco días mediante un calendario acelerado, orientación por fMRI y estimulación theta burst.",
  },
];

export const esFastDepressionTreatment = makeEsArticle({
  slug: "fast-depression-treatment",
  title: "Tratamiento rápido para la depresión | Neuro Wellness",
  description:
    "Tratamientos rápidos para la depresión: SAINT® TMS acelerada de cinco días y TMS convencional, autorizados por la FDA para la depresión resistente al tratamiento.",
  h1: "Tratamiento rápido para la depresión",
  breadcrumbLabel: "Tratamiento rápido",
  shortAnswer:
    "SAINT® es el protocolo de tratamiento para la depresión autorizado por la FDA más rápido: 50 sesiones en cinco días con orientación por fMRI. Está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. La TMS convencional, en comparación, dura unas seis semanas. La idoneidad la determina un psiquiatra tras una evaluación.",
  keyTakeaways: [
    "SAINT® es el protocolo autorizado por la FDA más rápido.",
    "50 sesiones en cinco días.",
    "Autorizado por la FDA (K220177) para adultos.",
    "La TMS convencional dura unas seis semanas.",
    "La idoneidad la determina un psiquiatra.",
  ],
  sections: [
    {
      heading: "SAINT® TMS acelerada",
      paragraphs: [
        "SAINT® administra 50 sesiones de estimulación theta burst durante cinco días consecutivos, con diez sesiones por día. Usa una resonancia magnética funcional (fMRI) para orientar la estimulación al circuito de cada persona. Está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos.",
      ],
    },
    {
      heading: "TMS convencional",
      paragraphs: [
        "La TMS convencional dura unas seis semanas, con sesiones diarias de lunes a viernes. SAINT® comprime el tratamiento en cinco días mediante un calendario acelerado.",
      ],
    },
    {
      heading: "Para quién es",
      paragraphs: [
        "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No está indicado para ansiedad, trastorno bipolar, TEPT u otras condiciones. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);

export const esFastestTreatment = makeEsArticle({
  slug: "fastest-treatment-for-severe-depression",
  title: "El tratamiento más rápido para la depresión grave | Neuro Wellness",
  description:
    "SAINT® es el protocolo de tratamiento para la depresión autorizado por la FDA más rápido: cinco días, 50 sesiones, para la depresión resistente al tratamiento.",
  h1: "El tratamiento más rápido para la depresión grave",
  breadcrumbLabel: "El tratamiento más rápido",
  shortAnswer:
    "SAINT® es el protocolo de tratamiento para la depresión autorizado por la FDA más rápido: 50 sesiones en cinco días con orientación por fMRI. Está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. En un ensayo controlado con simulación, el 79 % del grupo activo alcanzó la remisión. La idoneidad la determina un psiquiatra tras una evaluación.",
  keyTakeaways: [
    "SAINT® es el protocolo autorizado por la FDA más rápido.",
    "50 sesiones en cinco días.",
    "Autorizado por la FDA (K220177) para adultos.",
    "El 79 % del grupo activo alcanzó la remisión en el ensayo.",
    "La idoneidad la determina un psiquiatra.",
  ],
  sections: [
    {
      heading: "Por qué es el más rápido",
      paragraphs: [
        "SAINT® comprime el tratamiento en cinco días mediante un calendario acelerado, orientación por fMRI y estimulación theta burst. En un ensayo controlado con simulación, el 79 % del grupo activo alcanzó la remisión.",
      ],
    },
    {
      heading: "Para quién es",
      paragraphs: [
        "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No está indicado para ansiedad, trastorno bipolar, TEPT u otras condiciones. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
